"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _msal = require("msal");

/**
 * LocalStorage key
 */
var config = {
  // optional, clientId
  clientId: '56882e71-0fae-46a9-9538-0902cfc8cd74',
  // optional, authority
  authority: 'https://smartcityb2ctest.b2clogin.com/6538943e-fff4-4523-9ea8-b7c40fe1c39b/B2C_1_oneUFtest',
  // optional, the scopes
  scopes: ['https://smartcityb2ctest.onmicrosoft.com/56882e71-0fae-46a9-9538-0902cfc8cd74/user_impersonation']
};
/**
 * Configuration for msal request
 *
 * @returns {object} returns request configuration
 */

var request = function request() {
  return {
    scopes: config.scopes
  };
};
/**
 * login
 *
 * @param {Function} execute Execute after login
 * @returns {void}
 */


var login = function login(execute) {
  var localMsalApp = window.msal;

  if (!localMsalApp.getAccount()) {
    localMsalApp.loginRedirect(request());
  } else {
    localMsalApp.acquireTokenSilent(request()).then(function () {
      if (execute) {
        execute();
      }
    }, function () {
      localMsalApp.acquireTokenRedirect(request());
    });
  }
};
/**
 * Authentication service
 *
 */


var authentication = {
  /**
   * Inicialize config;
   *
   * @param {object} settings optional settings
   * optional, clientId
   * optional, authority
   * optional, scopes
   * @returns {void}
   */
  init: function init() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    config.clientId = settings.clientId || config.clientId;
    config.authority = settings.authority || config.authority;
    config.scopes = settings.scopes || config.scopes;
    new _msal.UserAgentApplication({
      auth: {
        clientId: config.clientId,
        authority: config.authority,
        validateAuthority: false,
        redirectUri: "".concat(window.location.protocol, "//").concat(window.location.host)
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
      }
    });
  },

  /**
   * Execute authentication flow
   *
   * @param {Function} app Execute app after finish flow
   * @returns {void}
   */
  run: function run(app) {
    if (!window.msal.isCallback(window.location.hash)) {
      login(app);
    }
  },

  /**
   * Authentication required part of app
   *
   * @param {Node} WrappedComponent WrappedComponent component
   * @param {Node} LoadingComponent LoadingComponent component
   * @returns {Function} Function component
   */
  required: function required(WrappedComponent) {
    var LoadingComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (props) {
      var _React$useState = _react["default"].useState(false),
          _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
          signedIn = _React$useState2[0],
          setSignedIn = _React$useState2[1];

      _react["default"].useEffect(function () {
        login(function () {
          setSignedIn(true);
        });
      }, []);

      if (signedIn) {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
      } else if (LoadingComponent !== null) {
        return /*#__PURE__*/_react["default"].createElement(LoadingComponent, props);
      } else {
        return null;
      }
    };
  },

  /**
   * Get valid access token for call api
   *
   * @returns {string} Valid access token
   */
  getToken: function () {
    var _getToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var localMsalApp, response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localMsalApp = window.msal;
              _context.prev = 1;
              _context.next = 4;
              return localMsalApp.acquireTokenSilent(request());

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.accessToken);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              login();
              return _context.abrupt("return", null);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    function getToken() {
      return _getToken.apply(this, arguments);
    }

    return getToken;
  }(),

  /**
   * Logout from app
   *
   * @returns {void}
   */
  logout: function logout() {
    var localMsalApp = window.msal;
    localMsalApp.logout();
  }
};
var _default = authentication;
exports["default"] = _default;